import "@fontsource-variable/manrope";
import "@fontsource-variable/vazirmatn";
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./router";
import { initializeAnalytics, trackPageView } from "./lib/analytics";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/home.css";
import "./styles/phase6.css";
import "./styles/catalog.css";
import "./styles/content.css";
import "./styles/mobile.css";
import "./styles/fa.css";

const rootElement = document.getElementById("root")!;
const app = <StrictMode><RouterProvider router={router} /></StrictMode>;

initializeAnalytics();
let trackedLocation = "";
const trackLocation = () => {
  const location = router.state.location;
  const nextLocation = `${location.pathname}${location.search}${location.hash}`;
  if (nextLocation === trackedLocation) return;
  trackedLocation = nextLocation;
  trackPageView(nextLocation);
};
trackLocation();
router.subscribe(trackLocation);

if (rootElement.dataset.prerenderPath === window.location.pathname && rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  rootElement.replaceChildren();
  createRoot(rootElement).render(app);
}
